import { type SVGProps } from "react";

export const Marketplace = (props: SVGProps<SVGSVGElement>) => (
  <svg
    preserveAspectRatio="xMidYMid meet"
    width="20px" height="20px" viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <style>
      {`
        .st0 { display: none; }
        .st1 { display: inline; }
        .st2 { fill: none; stroke: #B3B3B3; stroke-miterlimit: 10; }
        .st3 { fill: none; stroke: #ED1C24; stroke-miterlimit: 10; }
        .st4 { fill: #F9C04A; }
        .st5 { fill: #FFFFFF; stroke: #000000; stroke-width: 10; stroke-linecap: round; stroke-linejoin: round; stroke-miterlimit: 10; }
        .st6 { fill: #DEF6FC; }
        .st7 { fill: #FFDA9F; }
        .st8 { fill: #FFFFFF; }
        .st9 { fill: #FF5751; }
        .st10 { fill: #FF908A; }
        .st11 { fill: #133260; }
        .st12 { fill: #7782BB; }
        .st13 { fill: #96A5D6; }
        .st14 { fill: #FF5741; }
        .st15 { fill: #43527A; }
        .st16 { fill: #5E7296; }
        .st17 { fill: none; stroke: #133260; stroke-width: 9; stroke-linecap: round; stroke-linejoin: round; stroke-miterlimit: 10; }
        .st18 { fill: #83D689; }
        .st19 { fill: #B5F4B8; }
        .st20 { fill: #9BC5FF; }
        .st21 { fill: #B8D8FF; }
        .st22 { fill: #F24133; }
        .st23 { fill: #589FFF; }
        .st24 { fill: #7180BC; }
        .st25 { fill: #93A3D8; }
        .st26 { fill: #FF8103; }
        .st27 { fill: #FF9D4D; }
        .st28 { fill: #BC8D66; }
        .st29 { fill: #CEA282; }
        .st30 { fill: #FFDDA1; }
        .st31 { fill: #FFF1DC; }
        .st32 { fill: #7F6674; }
        .st33 { fill: #937A89; }
        .st34 { fill: #04398E; }
        .st35 { fill: #A6D1FF; }
        .st36 { fill: #EAA62D; }
        .st37 { fill: #C5DFFF; }
        .st38 { fill: #D6A47F; }
        .st39 { fill: #99A4D6; }
      `}
    </style>
    <g className="st0" id="Layer_31">

      <g className="st1">

        <g>

          <g>

            <ellipse className="st2" cx="256" cy="256" rx="248.1" ry="248.3" />

            <path className="st2" d="M398.8,504.5H113.2c-18.8,0-34.1-15.3-34.1-34.1V41.6c0-18.8,15.3-34.1,34.1-34.1h285.5      c18.8,0,34.1,15.3,34.1,34.1v428.9C432.9,489.3,417.6,504.5,398.8,504.5z" />

            <path className="st2" d="M7.9,399.8V112.2c0-16.4,13.3-29.8,29.8-29.8h436.7c16.4,0,29.8,13.3,29.8,29.8v287.6      c0,16.4-13.3,29.8-29.8,29.8H37.6C21.2,429.6,7.9,416.2,7.9,399.8z" />

            <path className="st2" d="M440.4,469.9H71.6c-16.4,0-29.8-13.3-29.8-29.8V71.9c0-16.4,13.3-29.8,29.8-29.8h368.8      c16.4,0,29.8,13.3,29.8,29.8v368.2C470.2,456.5,456.8,469.9,440.4,469.9z" />

          </g>

          <rect className="st3" height="497" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 512 5.684342e-14)" width="497" x="7.5" y="7.5" />

        </g>

      </g>

    </g>

    <g id="Layer_32">

      <g>

        <g>

          <g>

            <g>

              <g>

                <rect className="st6" height="326.4" width="436.1" x="38" y="130.7" />

                <rect className="st8" height="326.4" width="25.2" x="38" y="130.7" />

                <g>

                  <path className="st14" d="M76.4,130.7H4.6l35.8-94.9c5.2-13.9,18.5-23,33.3-23h34.5L76.4,130.7z" />

                  <path className="st10" d="M98.9,12.7H73.7c-14.8,0-28.1,9.2-33.3,23L4.6,130.7h25.2l35.8-94.9C70.8,21.9,84.1,12.7,98.9,12.7z" />

                  <polygon className="st14" points="148.2,130.7 76.4,130.7 108.2,12.7 167.3,12.7        " />

                  <polygon className="st14" points="220.1,130.7 148.2,130.7 167.3,12.7 226.4,12.7        " />

                  <polygon className="st14" points="291.9,130.7 220.1,130.7 226.4,12.7 285.6,12.7        " />

                  <polygon className="st14" points="363.8,130.7 291.9,130.7 285.6,12.7 344.7,12.7        " />

                  <polygon className="st14" points="435.6,130.7 363.8,130.7 344.7,12.7 403.8,12.7        " />

                  <path className="st14" d="M507.4,130.7h-71.8l-31.8-118h34.5c14.8,0,28.1,9.2,33.3,23L507.4,130.7z" />

                </g>

                <g>

                  <path className="st22" d="M40.5,199.8L40.5,199.8c-19.8,0-35.9-16.1-35.9-35.9v-33.2h71.8v33.2C76.4,183.7,60.3,199.8,40.5,199.8         z" />

                  <path className="st10" d="M29.8,163.9v-33.2H4.6v33.2c0,19.8,16.1,35.9,35.9,35.9h0c4.4,0,8.7-0.8,12.6-2.3         C39.5,192.4,29.8,179.3,29.8,163.9z" />

                  <path className="st22" d="M112.3,199.8L112.3,199.8c-19.8,0-35.9-16.1-35.9-35.9v-33.2h71.8v33.2         C148.2,183.7,132.2,199.8,112.3,199.8z" />

                  <path className="st22" d="M184.2,199.8L184.2,199.8c-19.8,0-35.9-16.1-35.9-35.9v-33.2h71.8v33.2         C220.1,183.7,204,199.8,184.2,199.8z" />

                  <path className="st22" d="M256,199.8L256,199.8c-19.8,0-35.9-16.1-35.9-35.9v-33.2h71.8v33.2C291.9,183.7,275.8,199.8,256,199.8z         " />

                  <path className="st22" d="M327.8,199.8L327.8,199.8c-19.8,0-35.9-16.1-35.9-35.9v-33.2h71.8v33.2         C363.8,183.7,347.7,199.8,327.8,199.8z" />

                  <path className="st22" d="M399.7,199.8L399.7,199.8c-19.8,0-35.9-16.1-35.9-35.9v-33.2h71.8v33.2         C435.6,183.7,419.5,199.8,399.7,199.8z" />

                  <path className="st22" d="M471.5,199.8L471.5,199.8c-19.8,0-35.9-16.1-35.9-35.9v-33.2h71.8v33.2         C507.4,183.7,491.4,199.8,471.5,199.8z" />

                </g>

              </g>

            </g>

            <path className="st15" d="M193.9,468.5H75.5V259.8c0-4.7,3.8-8.5,8.5-8.5h101.4c4.7,0,8.5,3.8,8.5,8.5V468.5z" />

            <path className="st16" d="M110.1,251.3H84c-4.7,0-8.5,3.8-8.5,8.5v208.7h26.1V259.8C101.6,255.1,105.4,251.3,110.1,251.3z" />

            <path className="st20" d="M420.2,371.2h-180c-7.7,0-13.9-6.2-13.9-13.9v-92.1c0-7.7,6.2-13.9,13.9-13.9h180      c7.7,0,13.9,6.2,13.9,13.9v92.1C434.1,365,427.9,371.2,420.2,371.2z" />

            <path className="st21" d="M248.6,357.3v-92.1c0-7.7,6.2-13.9,13.9-13.9h-25.2c-7.7,0-13.9,6.2-13.9,13.9v92.1      c0,7.7,6.2,13.9,13.9,13.9h25.2C254.8,371.2,248.6,365,248.6,357.3z" />

            <path className="st14" d="M483.2,499.3H28.8c-13.4,0-24.2-10.8-24.2-24.2v0c0-13.4,10.8-24.2,24.2-24.2h454.5      c13.4,0,24.2,10.8,24.2,24.2v0C507.4,488.5,496.6,499.3,483.2,499.3z" />

            <path className="st10" d="M28.8,450.9c-13.4,0-24.2,10.8-24.2,24.2v0c0,13.4,10.8,24.2,24.2,24.2h1v-48.4H28.8z" />

          </g>

          <path className="st6" d="M168.4,329H101c-2.6,0-4.6-2.1-4.6-4.6v-46.9c0-2.6,2.1-4.6,4.6-4.6h67.4c2.6,0,4.6,2.1,4.6,4.6v46.9     C173.1,326.9,171,329,168.4,329z" />

        </g>

        <g>

          <path className="st11" d="M483.2,446.3h-4.6V203.7c18.9-3.4,33.4-20,33.4-39.9v-33.2c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1     c0,0,0,0,0,0c0,0,0-0.1,0-0.1l0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0-0.4-0.1-0.8-0.3-1.2l-35.7-94.8c-5.9-15.5-21-26-37.6-26H73.7     c-16.6,0-31.7,10.4-37.6,26L0.3,129c-0.1,0.4-0.2,0.8-0.3,1.2c0,0,0,0,0,0c0,0,0,0.1,0,0.1l0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0     c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1v33.2c0,19.9,14.4,36.5,33.4,39.9v242.6h-4.6C12.9,446.3,0,459.2,0,475.1     c0,15.9,12.9,28.8,28.8,28.8h454.5c15.9,0,28.8-12.9,28.8-28.8C512,459.2,499.1,446.3,483.2,446.3z M502.9,163.9     c0,17.3-14.1,31.4-31.4,31.4s-31.4-14.1-31.4-31.4v-28.7h62.7V163.9z M185.4,246.8H84c-7.2,0-13,5.8-13,13v186.5H42.5v-242     c14.7-0.7,27.4-9.4,33.9-21.8c6.8,13,20.3,21.8,35.9,21.8s29.2-8.9,35.9-21.8c6.8,13,20.3,21.8,35.9,21.8s29.2-8.9,35.9-21.8     c6.8,13,20.3,21.8,35.9,21.8s29.2-8.9,35.9-21.8c6.8,13,20.3,21.8,35.9,21.8s29.2-8.9,35.9-21.8c6.8,13,20.3,21.8,35.9,21.8     s29.2-8.9,35.9-21.8c6.5,12.4,19.2,21.1,33.9,21.8v242h-271V259.8C198.5,252.6,192.6,246.8,185.4,246.8z M189.3,259.8v186.5H80.1     V259.8c0-2.2,1.8-3.9,3.9-3.9h101.4C187.6,255.9,189.3,257.7,189.3,259.8z M81,163.9v-28.7h62.7v28.7c0,17.3-14.1,31.4-31.4,31.4     S81,181.2,81,163.9z M152.8,163.9v-28.7h62.7v28.7c0,17.3-14.1,31.4-31.4,31.4S152.8,181.2,152.8,163.9z M296.5,163.9v-28.7h62.7     v28.7c0,17.3-14.1,31.4-31.4,31.4C310.5,195.3,296.5,181.2,296.5,163.9z M368.3,163.9v-28.7H431v28.7c0,17.3-14.1,31.4-31.4,31.4     C382.4,195.3,368.3,181.2,368.3,163.9z M438.3,17.3c12.8,0,24.5,8.1,29.1,20.1l33.5,88.8h-61.8L409.8,17.3H438.3z M400.4,17.3     l29.3,108.9h-62L350.1,17.3H400.4z M340.8,17.3l17.6,108.9h-62.2l-5.9-108.9H340.8z M230.7,17.3h50.5l5.9,108.9h-62.2L230.7,17.3     z M224.6,135.2h62.7v28.7c0,17.3-14.1,31.4-31.4,31.4s-31.4-14.1-31.4-31.4V135.2z M221.6,17.3l-5.9,108.9h-62.2l17.6-108.9     H221.6z M161.9,17.3l-17.6,108.9h-62l29.3-108.9H161.9z M44.6,37.4c4.5-12,16.2-20.1,29.1-20.1h28.6L72.9,126.1H11.1L44.6,37.4z      M9.1,163.9v-28.7h62.7v28.7c0,17.3-14.1,31.4-31.4,31.4S9.1,181.2,9.1,163.9z M483.2,494.7H28.8c-10.8,0-19.7-8.8-19.7-19.7     c0-10.8,8.8-19.7,19.7-19.7h454.5c10.8,0,19.7,8.8,19.7,19.7C502.9,485.9,494.1,494.7,483.2,494.7z" />

          <path className="st11" d="M240.2,375.7h180c10.2,0,18.4-8.3,18.4-18.4v-92.1c0-10.2-8.3-18.4-18.4-18.4h-180     c-10.2,0-18.4,8.3-18.4,18.4v92.1C221.8,367.5,230.1,375.7,240.2,375.7z M230.9,265.2c0-5.1,4.2-9.3,9.3-9.3h180     c5.1,0,9.3,4.2,9.3,9.3v92.1c0,5.1-4.2,9.3-9.3,9.3h-180c-5.1,0-9.3-4.2-9.3-9.3V265.2z" />

          <path className="st11" d="M168.4,268.2H101c-5.1,0-9.2,4.1-9.2,9.2v46.9c0,5.1,4.1,9.2,9.2,9.2h67.4c5.1,0,9.2-4.1,9.2-9.2v-46.9     C177.6,272.3,173.5,268.2,168.4,268.2z M168.5,324.3C168.5,324.4,168.5,324.4,168.5,324.3l-67.5,0.1c0,0-0.1,0-0.1-0.1v-46.9     c0,0,0-0.1,0.1-0.1h67.4c0,0,0.1,0,0.1,0.1V324.3z" />

        </g>

      </g>

    </g>

  </svg>
);
